import angular from 'angular';
import moment from 'moment';
import { map, reduce, filter } from 'lodash';

import { getTransactionNote } from 'application/util/transaction.util';
import { isCategoryBalanceUpdate } from 'application/util/category.util';
import receiptIcon from './image/icon-image.svg';

import './event-list-modal.style.sass';
import template from './event-list-modal.tpl.pug';

class EventListModalController {
    /* @ngInject */
    constructor($q, eventUtil, storageService) {
        this.$q = $q;
        this.eventUtil = eventUtil;
        this.storageService = storageService;
        this.receiptIconUrl = `url(${receiptIcon})`;

        this.groups = [];
    }

    $onChanges(changeObject) {
        if (changeObject.timestamp || changeObject.events) {
            const categoryIconStyle = this.storageService.getUserItem('category-icon-style') || 'icons';
            this.useCategoryIcons = categoryIconStyle === 'icons';
        }

        if (changeObject.timestamp) {
            this.date = moment(this.timestamp ? this.timestamp : null).format('MMMM D');
        }

        if (changeObject.events) {
            let events = changeObject.events.currentValue || [];

            let confirmedEvents = this.getEventsByConfirmation(events, true);
            let unconfirmedEvents = this.getEventsByConfirmation(events, false);

            this.groups = filter([
                {
                    name: 'Unconfirmed transactions',
                    value: this.getTotalValueOfEvents(unconfirmedEvents),
                    events: unconfirmedEvents
                },
                {
                    name: 'Confirmed transactions',
                    value: this.getTotalValueOfEvents(confirmedEvents),
                    events: confirmedEvents
                }
            ], (group) => group.events.length > 0);
        }
    }

    isBalanceUpdate(event) {
        return event && isCategoryBalanceUpdate(event.category);
    }

    getTotalValueOfEvents(events) {
        return reduce(events, (value, event) => value + this.eventUtil.getValue(event.type, event.value), 0);
    }

    getEventsByConfirmation(events, confirmed) {
        return map(filter(events, (event) => event.confirmed === confirmed), (event) => {
            return angular.merge({}, event, {
                actualNote: getTransactionNote(event.note, event.type, event.category),
                actualValue: this.eventUtil.getValue(event.type, event.value)
            });
        });
    }

    addEvent() {
        return this.onTransactionCreate({
            data: this.timestamp
        });
    }

    openEvent(transaction) {
        return this.onTransactionEdit({
            data: transaction
        });
    }

    toggleConfirmation(transaction) {
        transaction = angular.merge({}, transaction, {
            confirmed: !transaction.confirmed
        });

        let promise = this.onTransactionConfirmChange({
            data: transaction
        });

        return this.$q.when(promise).catch(() => null);
    }
}

export default {
    selector: 'dbAEventListModal',
    template: template(),
    controller: EventListModalController,
    bindings: {
        timestamp: '<',
        change: '<',
        balance: '<',
        events: '<',

        canAddEvent: '<',

        onTransactionCreate: '&',
        onTransactionEdit: '&',
        onTransactionConfirmChange: '&',
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-list-modal/event-list-modal.cmpt.js